import {PrgressBarModel} from "src/app/_models/common/prgressBarModel";

export interface IGradesForDelegateSetupResponse {
    gradeId: number;
    gradeName: string;
    assignedEmployeeCount: number;
    delegatorCount: number;
    delegateCount: number;
    updatedOn: number;
    isRowHighlighted: boolean;
    assignedDelegator: string;
    assignedDelegate: string;
    delegatorProgress:PrgressBarModel;
    delegateProgress:PrgressBarModel;
    selected: boolean;
    oldSelectedValue: boolean;
    disabled: boolean;
}

export class GradesForDelegateSetupResponse implements IGradesForDelegateSetupResponse {
    gradeId: number;
    gradeName: string;
    assignedEmployeeCount: number;
    delegatorCount: number;
    delegateCount: number;
    updatedOn: number;
    isRowHighlighted: boolean;
    assignedDelegator: string;
    assignedDelegate: string;
    delegatorProgress:PrgressBarModel;
    delegateProgress:PrgressBarModel;
    selected: boolean;
    oldSelectedValue: boolean;
    disabled: boolean;
    
}

export class DelegatorActivateListPanelInputModel {
    constructor(
        public title: string
       
    ) {}
}


export class DelegateActivateListPanelInputModel {
    constructor(
        public title: string
       
    ) {}
}

export class DelegatorActivatePanelInputModel {
    constructor(
        public title: string,
        public gradeId: number,
        public gradeName: string
    ) {}
}

export class DelegateActivatePanelInputModel {
    constructor(
        public title: string,
        public gradeId: number,
        public gradeName: string
    ) {}
}

export interface IUsersForActivateDelegatorDelegateResponse {
    employeeId: number;
    employeeName:string;
    employeeEmail:string;
    status: number;
    updatedOn: number;
    companyId:number;
    gradeId: number;
    isDelegator: boolean;
    isDelegate:boolean;
    companyName:string;
    countryName: string;
    roleId: number;
    isRowHighlighted: boolean;
    selected: boolean;
    delegateType: number;
    expdelegate: boolean;
    vendordelegate: boolean;
    oldDelegateType: number;
}


export class UsersForActivateDelegatorDelegateResponse implements IUsersForActivateDelegatorDelegateResponse {
    employeeId: number;
    employeeName:string;
    employeeEmail:string;
    status: number;
    updatedOn: number;
    companyId:number;
    gradeId: number;
    isDelegator: boolean;
    isDelegate:boolean;
    companyName:string;
    countryName: string;
    roleId: number;
    isRowHighlighted: boolean;
    selected: boolean;
    delegateType: number;
    expdelegate: boolean;
    vendordelegate: boolean;
    oldDelegateType: number;
}


export interface IUsersForActivateDelegatorDelegateRequest {
    organisationId: number;
    gradeId: number;
    DelegateType: number;
}

export class UsersForActivateDelegatorDelegateRequest implements IUsersForActivateDelegatorDelegateRequest {
    organisationId: number;
    gradeId: number;
    DelegateType: number;
    constructor(organisationId: number, gradeId: number) {
        this.organisationId = organisationId;
        this.gradeId = gradeId;
        this.DelegateType = 0;
    }
}


export interface IDelegatorDelegateByGradeModel {
    gradeId: number;
    isSelected: boolean;
}

export interface ISaveDelegatorDelegateByGradeRequest {
    organisationId: number;
    updatedBy: number;
    userName: string;
    type: number;
    gradeList: IDelegatorDelegateByGradeModel[];
}

export class SaveDelegatorDelegateByGradeRequest implements ISaveDelegatorDelegateByGradeRequest {
    organisationId: number;
    updatedBy: number;
    userName: string;
    type: number;
    gradeList: IDelegatorDelegateByGradeModel[];
}

export interface IDelegatorDelegateModel {
    userId: number;
    userName: string;
    isDelegator: boolean;
    isDelegate: boolean;
    oldDelegatorValue: boolean;
    oldDelegateValue: boolean;
    delegateType: number;
}

export interface ISaveDelegatorDelegateRequest {
    organisationId: number;
    updatedBy: number;
    userName: string;
    type: number;
    userList: IDelegatorDelegateModel[];
    gradeId: number;
}

export class SaveDelegatorDelegateRequest implements ISaveDelegatorDelegateRequest {
    organisationId: number;
    updatedBy: number;
    userName: string;
    type: number;
    userList: IDelegatorDelegateModel[];
    gradeId: number;
}

export class DelegatorsListPanelInputModel {
    constructor(
        public title: string
       
    ) {}
}

export class AssignDelegatePanelInputModel {
    constructor(
        public title: string,
        public selectedDelegateId: number,
        public selectedDelegateName: string
       
    ) {}
}

export interface IDelegateListForAssignmentResponse {
    delegateId: number;
    delegateName: string;
    delegateEmail: string;
}

export class DelegateListForAssignmentResponse implements IDelegateListForAssignmentResponse {
    delegateId: number;
    delegateName: string;
    delegateEmail: string;
}

export interface IAssignDelegateToDelegatorRequest {
    organisationId: number;
    delegatorId: number;
    delegateId: number;
    updatedBy: number;
    userName: string;
    delegatorName: string;
    delegatorEmail: string;
    delegateName: string;
    delegateEmail: string;
    oldDelegateId: number;
    oldDelegateName: string;
}

export class AssignDelegateToDelegatorRequest implements IAssignDelegateToDelegatorRequest {
    organisationId: number;
    delegatorId: number;
    delegateId: number;
    updatedBy: number;
    userName: string;
    delegatorName: string;
    delegatorEmail: string;
    delegateName: string;
    delegateEmail: string;
    oldDelegateId: number;
    oldDelegateName: string;
}


export interface IDelegatorsDetailsRequest {
    organisationId: number;
    delegatorId: number;
}

export class DelegatorsDetailsRequest implements IDelegatorsDetailsRequest {
    organisationId: number;
    delegatorId: number;
    constructor(organisationId: number, delegatorId: number) {
        this.organisationId = organisationId;
        this.delegatorId = delegatorId;
    }
}

export interface IDelegatorsDetailsResponse {
    delegatorId: number;
    delegatorName: string;
    delegatorEmail: string;
    updatedOn: number;
    companyName: string;
    countryName: string;
    roleId: number;
    assignDelegateId:number;
    assignDelegateDate: number;
    costCentreName: string;
    assignDelegateName: string;
    rights: string;
    rejectedExpenseCount: number;
    incompleteExpenseCount: number;
    incompleteCreditCardExpenseCount: number;
    isRowHighlighted: boolean;
    selected: boolean;
    assignDelegateEmail:number;
    log: any;
}

export class DelegatorsDetailsResponse implements IDelegatorsDetailsResponse {
    delegatorId: number;
    delegatorName: string;
    delegatorEmail: string;
    updatedOn: number;
    companyName: string;
    countryName: string;
    roleId: number;
    assignDelegateId:number;
    assignDelegateDate: number;
    costCentreName: string;
    assignDelegateName: string;
    rights: string;
    rejectedExpenseCount: number;
    incompleteExpenseCount: number;
    incompleteCreditCardExpenseCount: number;
    isRowHighlighted: boolean;
    selected: boolean;
    assignDelegateEmail:number;
    log: any;
}

export class AssignDelegateFormModel {
    public delegateId: number;
  }


  export interface IDelegateListForAssignmentRequest {
    organisationId: number;
 }

export class DelegateListForAssignmentRequest implements IDelegateListForAssignmentRequest {
    organisationId: number;
    constructor(organisationId: number) {
        this.organisationId = organisationId;
    }
}

export interface IClaimantDelegatorListRequest {
    organisationId: number;
    claimantId: number;
    isUnreportedExpenses: boolean;
}

export class ClaimantDelegatorListRequest implements IClaimantDelegatorListRequest {
    organisationId: number;
    claimantId: number;
    isUnreportedExpenses: boolean;
    constructor(organisationId: number, claimantId: number, isUnreportedExpenses: boolean) {
        this.organisationId = organisationId;
        this.claimantId = claimantId;
        this.isUnreportedExpenses = isUnreportedExpenses;
    }
}


export interface IUserDelegatorDelegateStatusRequest {
    organisationId: number;
    userId: number;
}

export class UserDelegatorDelegateStatusRequest implements IUserDelegatorDelegateStatusRequest{
    organisationId: number;
    userId: number;
    constructor(organisationId: number, userId: number) {
        this.organisationId = organisationId;
        this.userId = userId;
    }
}


export interface IUserDelegatorDelegateStatusResponse {
    userId: number;
    isDelegator: boolean;
    isDelegate: boolean;
}

export class UserDelegatorDelegateStatusResponse implements IUserDelegatorDelegateStatusResponse {
    userId: number;
    isDelegator: boolean;
    isDelegate: boolean;
}

export interface IBulkAssignDelegateToDelegatorRequest {
    organisationId: number;
    updatedBy: number;
    userName: string;
    assignmentList: AssignDelegateToDelegatorModel[];
}

export class BulkAssignDelegateToDelegatorRequest implements IBulkAssignDelegateToDelegatorRequest {
    organisationId: number;
    updatedBy: number;
    userName: string;
    assignmentList: AssignDelegateToDelegatorModel[];
}

export interface AssignDelegateToDelegatorModel {
    delegatorId: number;
    delegateId: number;
    delegatorName: string;
    delegatorEmail: string;
    delegateName: string;
    delegateEmail: string;
    oldDelegateId: number;
    oldDelegateName: string;
}